import { lighten } from '@mui/material';
import { DataGrid, GridRowIdGetter, GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid';
import { theme } from '../theme';
import TableActions from './TableActions';

interface DataTableGridProps {
  rows: any[];
  columns: any[];
  columnVisibilityModel?: any;
  handleSelectionChange?: (newSelection: GridRowSelectionModel) => void | undefined;
  rowSelectionModel?: GridRowSelectionModel | undefined;
  itemsSelected?: boolean;
  newOnClick?: () => void | null;
  newLabel?: string | null;
  getRowId?: GridRowIdGetter<any>;
  refreshData?: () => void | null;
  menuItems?:
    | {
        label: string;
        icon: React.ReactNode;
        onClick: () => void;
        hasDivider?: boolean;
        disabled?: boolean;
      }[]
    | null;
  secondarySlot?: React.ReactNode;
  pagination?: boolean;
  pageSize?: number;
  onRowClick?: (params: GridRowParams) => void;
  slots?: boolean
}
const DataTableGrid = ({
  rows,
  columns,
  columnVisibilityModel = {},
  handleSelectionChange,
  rowSelectionModel,
  itemsSelected,
  newOnClick,
  newLabel,
  getRowId,
  refreshData,
  menuItems,
  secondarySlot,
  pagination = false,
  pageSize = 10,
  onRowClick,
  slots
}: DataTableGridProps) => {

  const defaultPageSize = pageSize;
  const savedPageSize = pagination
    ? Number(localStorage.getItem('dataTablePageSize')) || defaultPageSize
    : defaultPageSize;

  return (
    <DataGrid
      // getRowId={getRowId}
      autoHeight
      rows={rows}
      columns={columns}
      hideFooter={!pagination}
      checkboxSelection={handleSelectionChange !== undefined}
      onRowSelectionModelChange={handleSelectionChange}
      rowSelectionModel={rowSelectionModel}
      slots={slots ? undefined : { toolbar: TableActions }}
      slotProps={{
        toolbar: {
          itemsSelected,
          btnOnclick: newOnClick,
          btnLabel: newLabel,
          refreshData,
          menuItems,
          secondarySlot,
        },
      }}
      onRowClick={onRowClick}
      localeText={{ noRowsLabel: 'No data' }}
      columnVisibilityModel={columnVisibilityModel}
      sx={{
        border: 'none',
        '& .MuiDataGrid-row': {
          cursor: onRowClick ? 'pointer' : 'default',
        },
        '& .MuiDataGrid-row:nth-of-type(odd)': {
          backgroundColor: lighten(theme.palette.primary.main, 0.95),
        },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: lighten(theme.palette.primary.main, 0.9),
        },
        '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row:hover.Mui-selected': {
          backgroundColor: lighten(theme.palette.primary.main, 0.8),
        },
      }}
      initialState={
        pagination
          ? {
              pagination: {
                paginationModel: {
                  page: 0,
                  pageSize: savedPageSize,
                },
              },
            }
          : undefined
      }
      pageSizeOptions={pagination ? [10, 25, 50] : undefined}
      onPaginationModelChange={(model) => {
        localStorage.setItem('dataTablePageSize', model.pageSize.toString());
      }}
    />
  );
};

export default DataTableGrid;
